import { Component } from '@angular/core';

@Component({
    selector: 'bag-page-shimmer',
    template: `
        <div fxLayout="column" fxLayoutAlign.gt-xs="center center">
            <span
                style="margin-top:'45px'; width:'100px'; height:'30px'"
            ></span>
        </div>
        <p fxHide.gt-xs></p>
        <div
            fxLayout="row"
            fxLayoutAlign="space-evenly"
            [ngStyle.gt-xs]="{ marginTop: '100px' }"
        >
            <span style="height:'180px';width:'500px'"></span>
            <div fxHide.xs style="height:'300px';width:'500px'">
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
            </div>
        </div>
    `,
    styleUrls: ['./bag-page-shimmer.component.scss'],
})
export class BagPageShimmerComponent {}
